const channelList = (state = {}, action) => {
  switch (action.type) {
    case 'CATEGORY_CHANGED':
      let property = Object.keys(action.payload.channels)[action.payload.index]
      return Object.assign({},action.payload.channels[property]);
    default:
      return state;
  }
}

export default channelList;



// WEBPACK FOOTER //
// ./src/reducers/channelsReducer.js